var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-modal',{attrs:{"title":"特殊权限设置","width":"450px","height":"600px"},on:{"show":_vm.showWindow},model:{value:(_vm.formVisible),callback:function ($$v) {_vm.formVisible=$$v},expression:"formVisible"}},[_c('vxe-grid',{ref:"xTable",attrs:{"border":"","size":"mini","height":_vm.height,"cell-class-name":_vm.cellClassName,"resizable":"","show-overflow":"","data":_vm.from,"edit-rules":_vm.validRules,"highlight-hover-row":"","highlight-current-row":"","mouse-config":{ area: true, extension: true },"edit-config":{ trigger: 'dblclick', mode: 'cell' },"keyboard-config":{
      isArrow: true,
      isDel: true,
      isEnter: true,
      isTab: true,
      isClip: true,
      enterToTab: true,
      isEdit: true,
      editMethod: _vm.editMethod,
    },"toolbar":_vm.tableToolbar,"columns":_vm.gridColumns},on:{"toolbar-button-click":_vm.toolbarButtonClickEvent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }